var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton"},_vm._l((8),function(item){return _c('div',{key:item,staticClass:"item"},[_c('div',{staticClass:"thumb"}),_vm._m(0,true)])}),0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body"},[_c('div',{staticClass:"title"}),_c('div',{staticClass:"info"})])
}]

export { render, staticRenderFns }